import React, { useState, useEffect } from "react";
import "../css/lifeinsurance.css";
import "../css/consultationform.css";
import lifeinsuranceimg from "../assets/lifeinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from 'react-helmet-async';

const LifeInsurance = () => {
  const API_URL = process.env.REACT_APP_Dashboard_API_URL;
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const imageSources = [
    lifeinsuranceimg,
    tollfreenumberimg,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % imageSources.length
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [imageSources.length]);

  const handleSubmit = async (data) => {
    const inquriyData = new FormData();
    inquriyData.append("Name", data.Name);
    inquriyData.append("Email", data.Email);
    inquriyData.append("PreferredDate", data.Date);
    inquriyData.append("PreferredTime", data.Time);
    inquriyData.append("MobileNo", data.MobileNo);
    inquriyData.append("Status", "New");
    inquriyData.append("UserId", data.Id);
    inquriyData.append("InquiryType", "Insurance Inquiries");
    inquriyData.append("PolicyType", "Life Insurance");
    inquriyData.append("IsLoggedIn", data.isLoggedIn);
    inquriyData.append("Otp", data.OTP);

    try {
      const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("Error submitting consultation request:", error);
      return {
        status: 500,
        data: {
          success: false,
          message: error.response?.data?.message
        }
      };
    }
  };

  return (
    <div className="lifeinsurance-container">
      <Helmet>
        <title>Life Insurance Advice | Choose The Right Policy Today</title>
        <meta
          name="description"
          content="Find clear, expert life insurance advice tailored to your goals. Compare plans, understand benefits, and protect your family’s future."
        />
        <meta
          name="keywords"
          content="life insurance advice, compare term insurance plans India, insurance advice India, best life insurance policies India, understand life insurance policy"
        />
        <link rel="canonical" href="https://policysamjho.com/life-insurance-advice/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Life Insurance Advice",
            "description": "Clear, expert guidance to help you choose the right life insurance policy for your needs. Compare plans, understand coverage, and get unbiased advice from the experts at Policy Samjho.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/"
            },
            "serviceType": "Life Insurance Consultation & Policy Guidance",
            "areaServed": "IN",
            "url": "https://policysamjho.com/life-insurance-advice/",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9584484800",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>

      <div className="lifeinsurance-hero-container">
        <div className="lifeinsurance-hero-text-box">
          <h1>
            <span style={{ color: '#192437' }}>Life Insurance </span>
            <span style={{ color: '#F5A526' }}>Advice</span>
          </h1>
          <p style={{ color: "black", fontWeight: "600", fontSize: "18px", textAlign: 'justify' }}>
            Protect your family's financial future with expert life insurance advice.
            Compare the best plans and find coverage that fits your long-term goals.
          </p>
        </div>
        <div className="lifeinsurance-hero-image-box lifeinsurance-imgslider">
          {imageSources.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Life Insurance Visual ${index + 1}`}
              className="lifeinsurance-sliderimg"
              style={{ display: index === currentImageIndex ? "block" : "none" }}
            />
          ))}
        </div>
      </div>

      <div className="lifeinsurance-containform-container">
        <div className="col-md-6 lifeinsurance-info">
          <h2 className="lifeinsurance-heading">
            <span style={{ color: "#192437" }}>What is </span>
            <span style={{ color: "#F5A526" }}>Life Insurance?</span>
          </h2>
          <p className="lifeinsurance-text">
            Life insurance is a contract between an individual and an insurance
            provider, where the insurer promises to pay a designated beneficiary
            a sum of money upon the insured's passing. It provides financial
            security, helping families cover expenses like mortgages, education,
            and daily living.
          </p>

          <h2 className="lifeinsurance-subheading">
            <span style={{ color: "#192437" }}>Why is Life / Term </span>
            <span style={{ color: "#F5A526" }}> Insurance Important</span>
          </h2>
          <ul className="lifeinsurance-benefits">
            <li className="lifepoints">Financial protection for your family</li>
            <li className="lifepoints">Long-term wealth and savings benefits</li>
            <li className="lifepoints">Coverage for outstanding debts and loans</li>
            <li className="lifepoints">Peace of mind for unforeseen emergencies</li>
          </ul>

          <h2 className="lifeinsurance-subheading">
            <span style={{ color: "#192437" }}> Extra Protection & </span>
            <span style={{ color: "#F5A526" }}>Perks Life Insurance</span>
          </h2>
          <p className="lifeinsurance-text spaced-text">
            Life insurance not only offers financial security but also serves as
            a long-term investment. Many policies come with savings and
            investment benefits that can help in wealth accumulation over time.
            Additionally, certain plans provide guaranteed returns, bonuses, or
            dividends, making them a reliable way to build financial stability.
          </p>
        </div>

        <div>
          <h4 className="consultationform-heading">
            <span style={{ color: "#192437" }}>Get a Free</span>
            <span style={{ color: "#F5A526" }}> Life Insurance Consultation</span>
          </h4>
          <ConsultationForm onSubmit={handleSubmit} />
        </div>
      </div>
      <PoliciesSlider category="Life Insurance" />
      <ChatbotAi />
    </div>
  );
};

export default LifeInsurance;
